<template>
    <div>
        <v-progress-linear
            :active="loadingIndicator"
            indeterminate
            absolute
            height="6"
            background-opacity="0.3"
            color="accent"
        ></v-progress-linear>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        name: 'LoadingIndicator',

        computed: {
            ...mapGetters({
                loadingIndicator: 'loadingIndicator/loadingIndicator'
            })
        }
    }
</script>
